import { LanguageFilterJson } from '@ninjacart/nc-nk-store';
import type { SizeTokens } from '@ninjacart/nc-nk-ui';
import { Label, Paragraph, RadioGroup, RootContainer, ScrollView, XStack, YStack , Text} from '@ninjacart/nc-nk-ui';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQnaFeedStore } from '../../store/useQnaStore';
import { Platform } from 'react-native';

interface ILanguageFilter{
  onFilterChange: (value: any) => void;
  setLangaugeBottomSheet: Dispatch<SetStateAction<boolean>>;
  currentLanguage: string;
}

export function LanguageFilter({ onFilterChange, setLangaugeBottomSheet, currentLanguage }: ILanguageFilter) {
  const setLanguageFilterName = useQnaFeedStore((state) => state.setLanguageFilterName);
  const setLanguageFilterValue = useQnaFeedStore((state) => state.setLanguageFilterValue);
  const languageFilterValue = useQnaFeedStore((state) => state.languageFilterValue);

  useEffect(() => {
    setLanguageFilterValue(currentLanguage);
  }, [currentLanguage]);

  const handleRadioChange = (value: string) => {
    setLanguageFilterValue(value);
    onFilterChange(value);
    setLangaugeBottomSheet(false);
    const languageLabel = LanguageFilterJson.find((lang) => lang.value === value);
    setLanguageFilterName(languageLabel?.name!);
  };

  return (
    <RootContainer flex={1}>
      <ScrollView contentContainerStyle={{ paddingVertical: 10 }}>
        <RadioGroupDemo selectedFilter={languageFilterValue} onValueChange={handleRadioChange} />
      </ScrollView>
    </RootContainer>
  );
}

const RadioGroupDemo = ({
  selectedFilter,
  onValueChange,
}: {
  selectedFilter: string | null;
  onValueChange: (value: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <RadioGroup aria-labelledby="Select a language" value={selectedFilter ?? ''} name="language">
      <XStack borderBottomWidth={3} borderBottomColor={'#D9D9D9'}>
        <Paragraph fontSize={20} fontWeight={'700'} marginBottom={20}>
          {t('page.selectLanguage')}
        </Paragraph>
      </XStack>
      <YStack space="$2">
        {LanguageFilterJson.map((language) => (
          <XStack
            key={language.value}
            marginTop={20}
            borderBottomWidth={1}
            borderBottomColor={'#D9D9D9'}
            testID="kisan_tId_language_valueChange_click"
          >
            <RadioGroupItemWithLabel
              onValueChange={onValueChange}
              size="$5"
              value={language.value}
              label={language.name}
              weight="600"
            />
          </XStack>
        ))}
      </YStack>
    </RadioGroup>
  );
};

export function RadioGroupItemWithLabel(props: {
  onValueChange: (value: string) => void;
  size: SizeTokens;
  value: string;
  label: string;
  weight: string;
}) {
  const id = `radiogroup-${props.value}`;

  const handleChange = () => {
    props.onValueChange(props.value);
  };

  return (
    <XStack
      width={'95%'}
      display={'flex'}
      alignItems="center"
      justifyContent="space-between"
      space="$1"
      onPress={handleChange}
      testID="kisan_tId_language_valueChange_click"
    >
      {/* label tag cause some issue so for timeBeing we r commented the label tag make it like Text tag */}
      {/* <Label fontSize={16} fontWeight={'400'}>
        {props.label ?? 'label'}
      </Label> */}
      
       <Text fontSize={16} paddingBottom={10} fontWeight={props.weight}>
        {props.label}
      </Text>
      <RadioGroup.Item onPress={handleChange} id={id} value={props.value} borderColor={'$primary'}>
        <RadioGroup.Indicator backgroundColor={'$primary'} width={12} height={12} />
      </RadioGroup.Item>
    </XStack>
  );
}
